module.exports = __webpack_public_path__ + "img/icon_cpoy.e3305173.svg";